module.exports = __webpack_public_path__ + "img/sixpackcarrier83.e4ba0ef0.jpg";